export const Permissions = {
    agentVisibility: "agentVisibility",
    approveRejectCompanyDocument: "approveRejectCompanyDocument",
    companyVisibility: "companyVisibility",
    createAdminDocument: "createAdminDocument",
    createAthlete: "createAthlete",
    createAthletePaymentRequest: "createAthletePaymentRequest",
    createCategory: "createCategory",
    createCompany: "createCompany",
    createCompanyDocument: "createCompanyDocument",
    createInvoice: "createInvoice",
    createMessage: "createMessage",
    createParent: "createParent",
    createSeason: "createSeason",
    createService: "createService",
    createUsers: "createUsers",
    deleteAdminDocument: "deleteAdminDocument",
    deleteAthlete: "deleteAthlete",
    deleteAthletePaymentRequest: "deleteAthletePaymentRequest",
    deleteCategory: "deleteCategory",
    deleteCompany: "deleteCompany",
    deleteCompanyDocument: "deleteCompanyDocument",
    deleteInvoice: "deleteInvoice",
    deleteMessage: "deleteMessage",
    deleteParent: "deleteParent",
    deleteSeason: "deleteSeason",
    globalVisibility: "globalVisibility"
}
